import React, { useState, useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Layout, Form, Input, Button, Row, Col, Modal, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setGolfClubDetails } from '../redux/actions/golfClubActions';
import {
  setDiscountCards,
  setMembershipTypes,
  setAlliances,
  setUserDetails,
} from '../redux/actions/generalActions';
import logo from './../assets/logo.png';
import greenfeeDealsApi from '../api/greenfeeDeals';
import axios from 'axios';
import config from '../config';
import jwt from 'jsonwebtoken';

const { Header, Footer, Content } = Layout;

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [auth, setAuth] = useState(false);
  const [, forceUpdate] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');

  const Login = async (values) => {
    try {
      const response = await greenfeeDealsApi.post('users/login', {
        email: values.username,
        password: values.password,
      });

      const apiResult = response.data;
      if (
        apiResult.status !== 'success' ||
        (apiResult.data.user.role !== 'admin' &&
          apiResult.data.user.role !== 'golfClubAdmin' &&
          apiResult.data.user.role !== 'subAdmin' &&
          apiResult.data.user.role !== 'dealAdmin')
      ) {
        message.error('Unauthorized user role');
        return;
      }

      localStorage.setItem('sessionBnd', apiResult.token);
      dispatch(setUserDetails(apiResult.data.user));

      const sessionBnd = localStorage.getItem('sessionBnd');
      const headers = { headers: { Authorization: `Bearer ${sessionBnd}` } };

      const golfClub = await axios.post(
        `${config.API_URL}/api/v1/golfclubs/golfClubAdmin`,
        {},
        headers
      );

      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        window.location.href = '/details';
        console.log('Error no Golfclub found for your Admin Account');
        return;
      }

      dispatch(setGolfClubDetails(golfClub.data.data.data));

      const membershipTypes = await axios.get(
        `${config.API_URL}/api/v1/memberships`,
        headers
      );
      if (
        membershipTypes.data.status === 'success' &&
        membershipTypes.data.results > 0
      ) {
        dispatch(setMembershipTypes(membershipTypes.data.data.data));
      }

      const discountCards = await axios.get(
        `${config.API_URL}/api/v1/discountcards`,
        headers
      );
      if (
        discountCards.data.status === 'success' &&
        discountCards.data.results > 0
      ) {
        dispatch(setDiscountCards(discountCards.data.data.data));
      }

      const alliances = await axios.get(
        `${config.API_URL}/api/v1/alliances`,
        headers
      );
      if (
        alliances.data.status === 'success' &&
        alliances.data.results > 0
      ) {
        dispatch(setAlliances(alliances.data.data.data));
      }

      window.location.href = '/details';
    } catch (error) {
      console.log('Error logging in:', error);
      message.error('Login failed. Please check your credentials.');
    }
  };

  const handleForgotPassword = async () => {
    if (!forgotEmail) {
      message.warning('Please enter your email');
      return;
    }
    try {
      const res = await greenfeeDealsApi.post('users/forgotPassword', {
        email: forgotEmail,
      });

      if (res.data.status === 'success') {
        message.success('Password reset link has been sent to your email.');
        setIsModalVisible(false);
        setForgotEmail('');
      } else {
        message.error(res.data.message || 'User not found');
      }
    } catch (err) {
      console.log(err);
      message.error('Something went wrong. Please try again later.');
    }
  };

  useEffect(() => {
    forceUpdate({});
    const token = localStorage.getItem('sessionBnd');
    if (token) {
      const decodedToken = jwt.decode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken?.exp > currentTime) {
        window.location.href = '/details';
      }
    }
  }, []);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ backgroundColor: '#293642' }}></Header>
      <Content
        style={{
          backgroundColor: '#293642',
          color: 'white',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <div>
          <Row>
            <Col span={24} justify="center" align="center">
              <img
                src={logo}
                alt="Logo"
                width={200}
                style={{ paddingBottom: 50, marginTop: -40 }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form
                form={form}
                name="horizontal_login"
                layout="inline"
                onFinish={Login}
              >
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: 'Bitte geben Sie einen Benutzername ein!',
                    },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Username"
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Bitte geben Sie ein Passwort ein!',
                    },
                  ]}
                >
                  <Input
                    prefix={<LockOutlined />}
                    type="password"
                    placeholder="Passwort"
                  />
                </Form.Item>
                <Form.Item shouldUpdate>
                  {() => (
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={
                        !form.isFieldsTouched(true) ||
                        form
                          .getFieldsError()
                          .filter(({ errors }) => errors.length).length
                      }
                    >
                      Log in
                    </Button>
                  )}
                </Form.Item>
              </Form>
              <div style={{ textAlign: 'center', marginTop: 10 }}>
                <a
                  onClick={() => setIsModalVisible(true)}
                  style={{ color: '#40a9ff', cursor: 'pointer' }}
                >
                  Forgot Password?
                </a>
              </div>
            </Col>
          </Row>
        </div>

        {/* Forgot Password Modal */}
        <Modal
          title="Forgot Password"
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsModalVisible(false)}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={handleForgotPassword}
            >
              Send Reset Link
            </Button>,
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="Enter your email"
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
          />
        </Modal>
      </Content>
      <Footer style={{ backgroundColor: '#293642' }}></Footer>
    </Layout>
  );
}

export default SignIn;
